import { getNavigationType } from '../../utils/get-navigation-type.js';
export const buildViewSalesPosterEvent = (inputProperties) => ({
    ...inputProperties,
    object: Promise.resolve(inputProperties.object).then((objectProperties) => {
        const { articleId, ...rest } = objectProperties;
        return {
            ...rest,
            id: articleId,
            navigationType: getNavigationType(),
            type: 'SalesPoster',
            url: window.location.href,
        };
    }),
});
//# sourceMappingURL=event-builder.js.map